export default __webpack_public_path__ + "static/keep-ya-mind-sharp_record-c5ae66ba739167f830e15ca42f61b6ce.png";